<template>
  <NuxtLayout :name="layout">
    <LazyAppErrorsRvUnpublished
      v-if="isRvUnpublishedError"
      :error="props.error"
    />

    <AppErrorsDefault
      v-else
      :error="error"
    />
  </NuxtLayout>
  <LazyAppAuthModal v-if="!isLoggedIn || profileCompletionPending" />
</template>

<script setup lang="ts">
import type { NuxtError } from '#app'

const props = defineProps<{
  error: NuxtError
}>()

/**
 * There's an issue where the session is not fetched when loading the error page.
 * This is a workaround to fetch the session and when a token is present.
 */
const { isLoggedIn } = useAuthentication()
const { rawToken } = useAuthState()
const { getSession } = useAuth()
if (rawToken.value) {
  await getSession()
}

const { t } = useI18n()
const profileCompletionPending = useProfileCompletionPending()

const isRvUnpublishedError = computed(() => props.error.statusMessage === 'RV_UNPUBLISHED')

const { isWebView } = usePlatform()
const layout = computed(() => isWebView.value ? 'blank' : 'default')

const title = computed(() => {
  return isRvUnpublishedError.value
    ? t('pages.error.title.rvUnpublished')
    : props.error.statusCode === 404
      ? t('pages.error.title.fourOhFour')
      : t('pages.error.title.others')
})

const { isPotentiallyABot } = useBotScore()

if (!isPotentiallyABot) {
  useHead({
    title,
  })
}

if (isMetaServer && isRvUnpublishedError.value) {
  useSeoMeta({
    robots: 'noindex follow',
  })
}
</script>

<i18n src="~~/i18n/locales/common/pages/error.json" lang="json" />
